import React from 'react';

// Импортируем модульные стили
import styles from './LeadMagnetSection.module.css';

// Импортируем изображение-заглушку для обложки PDF.
// Оно должно лежать в /public/images/
const pdfCoverImage = '/images/pdf-cover-placeholder.png';

const LeadMagnetSection = () => {
  return (
    // Эта секция будет яркой, чтобы привлечь максимум внимания.
    <section id="lead-magnet" className={styles.leadMagnetSection}>
      <div className={`container ${styles.container}`}>
        
        {/* Блок с изображением обложки PDF */}
        <div className={styles.imageWrapper}>
          <img src={pdfCoverImage} alt="Обложка PDF-руководства по выбору БРУ" className={styles.coverImage} />
        </div>

        {/* Блок с текстовым контентом и кнопкой */}
        <div className={styles.contentWrapper}>
          <h2 className={styles.title}>
            Как выбрать бетонный завод и не ошибиться?
          </h2>
          <p className={styles.description}>
            Получите наше <strong>бесплатное руководство</strong>, в котором мы сравниваем типы БРУ,
            разбираем ключевые характеристики и даем чек-лист для выбора надежного поставщика.
          </p>
          {/* 
            Эта кнопка ведет на секцию с контактами.
            В более сложной реализации она могла бы открывать модальное окно
            с формой для ввода email.
          */}
          <a href="#contact" className={styles.downloadButton}>
            Скачать PDF-руководство
          </a>
        </div>

      </div>
    </section>
  );
};

export default LeadMagnetSection;